<template>
<div>
	<div class="mt-1 relative">
	
	<!-- label for file input -->
	<label v-if="type === 'file'" class="absolute text-sm font-medium text-gray-600 bg-white pr-10">{{label}}</label>
	
	<!-- label for field input-->
	<div :class="invert ? 'text-white':'text-gray-800' " >
		<label class="block text-sm font-medium text-gray-600" >
			
			{{(type !== 'file') ? label : fileName}}
				<!-- normal input  -->
				<input
					v-if="!multiline && !datalist"
					v-model="model"
					:type="type"
					:name="name"
					:min="min"
					:max="max"
					:list="list"
					@focus="$emit('focused')"
					@blur="$emit('unfocused')"
					:accept="accept"
					:disabled="disabled"
					:maxlength="maxlength"
					:autocomplete="autocomplete"
					:placeholder="placeholder"
					:aria-invalid="showError ? 'true' : 'false'"
					:aria-describedby="name + '-' + error"
					:class="[showError ?
					'border-2 border-red-600 focus:ring-red-500 focus:border-red-500' :
					'focus:ring-blue-500 focus:border-blue-500']"
					class="bg-gray-50 text-gray-800 px-3 pr-3 block w-full border border-gray-300 py-2.5 text-sm focus:outline-none rounded-lg"
				>
				<div v-if="placeholder.includes('Search')" class="w-full flex justify-end pr-3 text-gray-600 -mt-[35px] mb-5">
					<slot></slot>
				</div>
				<!-- textarea input -->
				<textarea
					v-if="multiline"
					v-model="model"
					:name="name"
					:maxlength="maxlength"
					:autocomplete="autocomplete"
					:placeholder="placeholder"
					:aria-invalid="showError ? 'true' : 'false'"
					:aria-describedby="name + '-' + error"
					:class="showError ?
						'border-2 border-red-600 focus:ring-red-500 focus:border-red-500' :
						'focus:ring-blue-500 focus:border-blue-500'"
					class="bg-gray-50 px-3 pr-3 py-2.5 text-sm block w-full border border-gray-300 focus:outline-none rounded-md"
				>
				</textarea>
				<!-- file upload icon -->
				<div v-if="type === 'file'" class="absolute mt-5 mr-1 inset-y-0 right-0 px-3 flex items-center pointer-events-none">
					<LucideIcon name="Upload" :size='`${small ? 14:18}`' :stroke-width="2.5" color="#4b5563"/>
				</div>
			</label>
		</div>
	</div>

	<!-- error text -->
	<p v-if="showError" class="text-sm font-medium text-red-700 whitespace-normal">{{error}}</p>
</div>
</template>

<script>
import LucideIcon from "@/components/LucideIcon.vue";
export default {
	name: "CustomInput",
	props: {
	modelValue: String,
	label: {
		type: String,
		default: ""
	},
	placeholder: {
		type: String,
		default: ""
	},
	error: {
		type: String,
		default: ""
	},
	type: {
		type: String,
		default: "text"
	},
	name: {
		type: String,
		default: ""
	},
	autocomplete: {
		type: String,
		default: ""
	},
	multiline: {
		type: Boolean,
		default: false
	},
	datalist: {
		type: Boolean,
		default: false
	},
	options: {
		type: Array
	},
	disabled: {
		type: Boolean
	},
	bigInput: {
		type: Boolean
	},
	searchResults: {
		type: Array
	},
	value: {
		type: undefined
	},
	list: String,
	min: String,
	max: String,
	accept: String,
	maxlength: String,
	invert: {
		type:Boolean,
		default:false
	}
	},
	components:{
		LucideIcon
	},

	data(){
		return {
			test:""
		}
	},

	computed: {
		showError() {
			if (this.error.length > 0) return true;
			return false;
		},
		model: {
		get() {
			return this.modelValue;
		},
		set(value) {
			this.$emit('update:modelValue', value);
		}
		},
		fileName() {
			if (typeof this.value !== 'string') return "Upload file"
			let filePathArray = this.value.split('\\');
			return filePathArray[filePathArray.length - 1]
		}
	}
}
</script>
